import { useEffect, useState } from 'react';

import Configuration from 'redpoints-connector-common/helper/Configuration';

import { redirect } from 'redpoints-front-common/helpers';

import { ROUTES } from '../../../../config/constants';
import FilterByEnum from '../../../../enumerations/FilterBy';
import { getContextDataFromFilterBy } from '../testPurchaseFiltersHelpers';

const useTestPurchaseSetInitialData = ({
  allDomainIds,
  context,
  filtersFromQueryParams,
  hasFiltersApplied,
  hasSomeQueryParams,
  isLoadedDomains,
  testPurchaseFetchLinkInfo,
  testPurchaseSetFiltersSelected,
  initialSelectedFilterBy,
}) => {
  const [isEnableFilterByTenant, setIsEnableFilterByTenant] = useState(null);
  const [isInitialized, setIsInitialized] = useState(!hasSomeQueryParams);
  const mustInitialize =
    !isInitialized && isLoadedDomains && isEnableFilterByTenant != null;

  const filterByToFetch =
    filtersFromQueryParams.filterBy ?? initialSelectedFilterBy;

  const { customerId, contractId } = getContextDataFromFilterBy(
    filterByToFetch,
    context
  );

  useEffect(() => {
    const getConfiguration = async () => {
      try {
        const configuration = await Configuration.getJSONConfig();
        setIsEnableFilterByTenant(
          configuration.task?.enableFilterByTenant ?? false
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    getConfiguration();
  }, []);

  useEffect(() => {
    const mustRedirect =
      !isInitialized &&
      isLoadedDomains &&
      isEnableFilterByTenant === false &&
      filtersFromQueryParams.filterBy === FilterByEnum.TENANT.name;

    if (mustRedirect) {
      redirect({
        queryParams: {
          ...filtersFromQueryParams,
          filterBy: initialSelectedFilterBy,
        },
        urlRoute: ROUTES.TEST_PURCHASE,
      });
    }
  }, [
    filtersFromQueryParams,
    initialSelectedFilterBy,
    isEnableFilterByTenant,
    isInitialized,
    isLoadedDomains,
  ]);

  useEffect(() => {
    const mustSetInitialFilters = mustInitialize && !hasFiltersApplied;

    if (mustSetInitialFilters) {
      const { domainId, domainPlatformId, filterBy } = filtersFromQueryParams;
      testPurchaseSetFiltersSelected({ domainId, domainPlatformId, filterBy });
    }
  }, [
    filtersFromQueryParams,
    hasFiltersApplied,
    hasSomeQueryParams,
    mustInitialize,
    testPurchaseSetFiltersSelected,
  ]);

  useEffect(() => {
    const mustFetchLink = mustInitialize && hasFiltersApplied;

    if (mustFetchLink) {
      testPurchaseFetchLinkInfo({
        allDomainIds,
        contractId,
        customerId,
      });
    }
  }, [
    allDomainIds,
    contractId,
    customerId,
    filtersFromQueryParams,
    hasFiltersApplied,
    mustInitialize,
    testPurchaseFetchLinkInfo,
  ]);

  useEffect(() => {
    const mustSetAsInitialized = mustInitialize && hasFiltersApplied;
    if (mustSetAsInitialized) {
      setIsInitialized(true);
    }
  }, [mustInitialize, hasFiltersApplied]);

  return { isEnableFilterByTenant };
};

export default useTestPurchaseSetInitialData;
